/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * baseImgPath: 图片存放地址
 *

 */
let baseUrl = '';
let apiUrl = '';
let routerMode = 'history';


//let baseImgPath = 'http://106.53.81.229:5080/sy-img/';
//let uploadImgPath = "http://106.53.81.229:5080/sy-img/uploadImages?type=lansi";
//let deleteImgPath = "http://106.53.81.229:5080/sy-img/";
// let baseImgPath = 'https://mp.ch-blueocean.org/sy-img/';
// let uploadImgPath = "https://mp.ch-blueocean.org/sy-img/uploadImages?type=lansi";
// let deleteImgPath = "https://mp.ch-blueocean.org/sy-img/";
let baseImgPath = 'https://mp.broc.org.cn/sy-img/';
let uploadImgPath = "https://mp.broc.org.cn/sy-img/uploadImages?type=lansi";
let deleteImgPath = "https://mp.broc.org.cn/sy-img/";
//let baseImgPath = 'http://localhost:9090/';
//let uploadImgPath = "http://localhost:9090/uploadImages?type=lansi";
//let deleteImgPath = "http://localhost:9090/deleteImage?";
let wxPath = "";
let adminUrl="http://localhost:8002";
if (process.env.NODE_ENV == 'development') {
	baseUrl = 'http://localhost:9098/';
	//baseUrl = 'http://106.53.81.229:5080/lansi-web-admin/';
	

}else{
	// baseUrl = 'https://mp.ch-blueocean.org/lansi-web-admin/';
	// adminUrl="https://mp.ch-blueocean.org";
	baseUrl = 'https://mp.broc.org.cn/lansi-web-admin/';
	adminUrl="https://mp.broc.org.cn";
	//baseUrl = 'http://nyzhonghe.i-sanya.com/nyzhonghe-web-admin/';
}

export {
	baseUrl,
    apiUrl,
	routerMode,
	baseImgPath,
	uploadImgPath,
    deleteImgPath,
    wxPath,
	adminUrl,
}



// WEBPACK FOOTER //
// ./src/config/env.js